export default __webpack_public_path__ + "static/granulationring-40fab92ae349f4b5adc8c80e74f8741f.png";